import { SESSION_LOCALE } from 'utils/constants'
import { getCurrentLocaleSymbols } from 'utils/functions'

const localeLocalStorageItem = localStorage.getItem(SESSION_LOCALE)
const state = localeLocalStorageItem
  ? { selected: localeLocalStorageItem, symbols: getCurrentLocaleSymbols(localeLocalStorageItem) }
  : { selected: 'pt_BR', symbols: getCurrentLocaleSymbols('pt_BR') }

const actions = {
  change ({ commit }, locale) {
    commit('change', locale)
  }
}

const mutations = {
  change (state, locale) {
    localStorage.setItem(SESSION_LOCALE, locale)
    state.selected = locale
    state.symbols = getCurrentLocaleSymbols(locale)
  }
}

const locale = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default locale
